const GlobalConfigActionConstants = {
  // UPDATED_CURRENT_USER_MANAGEMENTGROUP is used to trigger the load of the ControlTowerExperience MDS data
  LOADING_CONTROL_TOWER_EXPERIENCE: "GlobalConfigActionConstants/LOADING_CONTROL_TOWER_EXPERIENCE",
  LOADED_CONTROL_TOWER_EXPERIENCE: "GlobalConfigActionConstants/LOADED_CONTROL_TOWER_EXPERIENCE"
};
export {
  GlobalConfigActionConstants as default
};
//# sourceMappingURL=GlobalConfigActionsConstants.js.map
